import React, { Fragment, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { useParams, useLocation } from 'react-router-dom';
import MainScreen from "../CommonPage/MainScreen.component";
import { userActions } from "../../redux/actions/user.actions";

const VerifyPage = ({ loading, history }) => {
  const inputsRef = useRef([]);
  const location = useLocation();
  const dispatch = useDispatch();
  const { email, validationToken } = useParams();
  
  const [code, setCode] = useState(['', '', '', '', '', '']);

  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);

      if (value && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const fullCode = code.join('');
    if (fullCode.length === 6) {
      const { from } = location.state || {
        from: { pathname: "/CompanyMenuDetails" },
      };
      dispatch(userActions.verify2FA(email, validationToken, fullCode, from, history));
    }
  };

  return (
    <Fragment>
      <MainScreen
      content={
        <div className="container  py-2">
          <form>
            <table style={{width: '100%'}}>
              <tr>
                <td>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <h2>Enter 2FA Code</h2>
                  <p>Check your authenticator app for the 6-digit code.</p>

                  <div style={{ display: 'flex', gap: '0.5rem', margin: '1rem 0' }}>
                    {code.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        ref={(el) => (inputsRef.current[index] = el)}
                        style={{
                          width: '3rem',
                          height: '3rem',
                          fontSize: '1.5rem',
                          textAlign: 'center',
                          borderRadius: '0.5rem',
                          border: '1px solid #ccc',
                        }}
                      />
                    ))}
                  </div>
                </div>
                </td>
              </tr>
              <tr>
                <td className="py-3"></td>
              </tr>
              <tr>
                <td>
                  {" "}
                  <div className="form-group">
                    <button
                      className="buttonActive w-100"
                      type="submit"
                      id="loginToPrime"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? 'Verifying...' : 'Verify'}
                    </button>
                  </div>
                </td>
              </tr>
            </table>

            <br />
            <hr className="my-12" />
            <br />
            <div className="form-group">
              <div className="col-auto col-md-12 text-center ">
                <span
                  style={{
                    fontSize: "16px",
                    lineHeight: "19.36 px",
                    color: "#A6A6A6",
                    fontStyle: "normal",
                    fontWeight: "400",
                    letterspacing: "0.25px",
                  }}
                >
                  {" "}
                  Don't have an account?
                </span>

                <a
                  href={() => false}
                  style={{
                    fontSize: "16px",
                    lineHeight: "19.36 px",
                    color: " #012040",
                    fontStyle: "normal",
                    fontWeight: "550",
                    letterspacing: "0.25px",
                  }}
                  className="hand-cursor   text-decoration-none"
                  onClick={() => {}}
                >
                  {" "}
                  Register here
                </a>
              </div>
            </div>
          </form>
        </div>
      }
    />
    </Fragment>
  );
};

export default VerifyPage;
